import { imgixHost } from 'src/config'
import Model from 'src/models/model'

export default class ImageAsset extends Model {
  static name = 'ImageAsset'

  static noId = true

  static define () {
    this.fields = {
      image: {
        type: String,
        required: true
      },
      filename: {
        type: String,
        output: true
      },
      contentType: {
        type: String,
        output: true
      }
    }

    this.paginate = true
  }

  get name () {
    return this.filename
  }

  get thumbnailUrl () {
    return `${imgixHost}/${this.image}?max-w=100&auto=format`
  }

  get imageUrl () {
    return `${imgixHost}/${this.image}?max-w=1000&auto=format`
  }
}
